module.exports = __webpack_public_path__ + "static/media/creedo.b7f1f678.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/creedo.png
// module id = 400
// module chunks = 0